import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { DpTableComponent } from '../../../../common-component/dp-table/dp-table.component';
import { PrivilegeCellComponent } from '../../../../table-cell/privilege-cell.component';
import { PermissionsButtonComponent } from '../../../../table-cell/manage-userPermission-button-cell.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';
import { ToastrService } from 'ngx-toastr';
import { ManageUserService } from '../../../../services/raintree/Transmission/manage-user.service';
import { PermissionList } from '../../../../services/raintree/interfaces/manage-user';
import { forkJoin, map, tap } from 'rxjs';
import { response } from 'express';
import { StateDistrictDialogComponent } from '../state-district-dialog/state-district-dialog.component';
import { PermissionViewerComponent } from "../permission-viewer/permission-viewer.component";
import { StateDistrictPopupComponent } from '../../../../manage-user/state-district-popup/state-district-popup.component';
import { SaveConfirmManageUserComponent } from '../save-confirm-manage-user/save-confirm-manage-user.component';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { SatesListService } from '../../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../../services/raintree/Transmission/district-list.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-manage-userPermission-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    LoaderComponent,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule
  ],
  templateUrl: './manage-newRole-dialog.component.html',
  styleUrls: [
    './manage-newRole-dialog.component.scss',
    '../../../../../styles/_dropdown.scss',
  ],
})

export class ManageNewRoleDialogComponent implements OnInit {

  isMobileView: boolean = false;
  statusActive: boolean = false;

  userForm!: FormGroup;
  isLoading: boolean = false;
  userData: any;

  selectRole = new FormControl([Validators.required]);
  role_level!: string;
  states: any[] = [];
  districts: any[] = [];
  districtList: any[] = [];
  selectedState: any = [];
  selectedDistrict: string | null = null;
  workerList: any[] = [];
  selectedWorker: string | null = null;

  showState: boolean = false;
  showDistrict: boolean = false;
  districtReqRoles: any;
  stateReqRoles: any;
  optionalAreaReqRoles: any;
  noAreaReqRoles: any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private _manageUserService: ManageUserService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ManageNewRoleDialogComponent>,
    private appConfigService: AppConfigService,
    private stateTransmissionService: SatesListService,
    private districtListService: DistrictListService,
  ) { }


  manageUserPermALL: any = []
  manageUserPermWithLoc: any = []
  ngOnInit(): void {
    this.isLoading = true;
    this.isMobileView = this.isMobile.isMobileDevice();

    this.userForm = new FormGroup({
      userStatus: new FormControl(this.statusActive),
    });


    this.userData = this.data.userDetails

    this.states = this.data.states;
    this.districts = this.data.districts;
    this.role_level = this.data.level;

    this.districtReqRoles = this.data.districtReqRoles;
    this.stateReqRoles = this.data.stateReqRoles;
    this.optionalAreaReqRoles = this.data.optionalAreaReqRoles;
    this.noAreaReqRoles = this.data.noAreaReqRoles;

    if (this.stateReqRoles.includes(this.role_level)) {
      this.showState = true;
    }

    if (this.districtReqRoles.includes(this.role_level) || this.optionalAreaReqRoles.includes(this.role_level)) {
      this.showState = true;
      this.showDistrict = true;
    }

    if (this.role_level == "PR/SPR WORKER") {
      this._manageUserService.getWorkerRoleList().subscribe({
        next: (response) => {
          // this.changedPermissions=[];
          if (!response.error) {
            this.isLoading = false;
            this.workerList = response.data
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        }
      });
    } else
      this.isLoading = false;
    // this.loaduserPermissionList();
  }
  closeDialog() {
    this.dialogRef.close(true);
  }

  onStateChange(state: any) {
    this.selectedState = state;
    if (!this.districts[state] || this.districts[state].includes('ALL')) {
      this.districtListService.getDistrictList(this.selectedState).pipe(
        map((response: any) => response.data.map((elm: any) => elm.district_name)),
        tap(res => {
          console.log(res, "states");
          this.districtList = res;
        })).subscribe();
    } else {
      this.districtList = this.districts[state];
    }
  }

  onDistrictChange(district: string) {
    this.selectedDistrict = district;
  }

  onWorkerChange(workerRole: string) {
    this.selectedWorker = workerRole;
  }

  clearStateSelection() {
    this.selectedState = '';
    this.selectedDistrict = null;
  }
  clearDistrictSelection() {
    this.selectedDistrict = null;
  }


  saveChanges() {
    this.isLoading = true;
    if (this.selectedState == '') this.selectedState = null;
    if (this.selectedDistrict == '') this.selectedDistrict = null;

    let isValidReq = true;
    if (this.districtReqRoles.includes(this.role_level) && (this.selectedState == null || this.selectedDistrict == null)) {
      this.isLoading = false;
      isValidReq = false;
      this.toaster.success('Please select State and District.')
    }

    if (this.stateReqRoles.includes(this.role_level) && this.selectedState == null) {
      this.isLoading = false;
      isValidReq = false;
      this.toaster.success('Please select State.')
    }

    if (this.role_level == "PR/SPR WORKER" && this.selectedWorker == null) {
      this.isLoading = false;
      isValidReq = false;
      this.toaster.success('Please select Worker Type.')
    }

    if (isValidReq) {
      const bodyObj = {
        newLoc_state: this.selectedState,
        newLoc_district: this.selectedDistrict,
        roleId: this.role_level,
        workerType: this.selectedWorker,
      }
      this._manageUserService.attachNewRole(this.data.userDetails.id, bodyObj).subscribe({
        next: (response) => {
          // this.changedPermissions=[];
          if (!response.error) {
            this.isLoading = false;
            this.toaster.success('Area has been added successfully')
            this.dialogRef.close(true)
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toaster.error(error);
        }
      });
    }
  }

};